import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

import { config, time, messages } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { templateTypes } from 'app/constants/templates/template-type';
import { currency } from 'app/constants/currency.constants';
import { DataService, HTTPService, HelperService, DateService, AttachmentService } from 'app/services';
import { UpdateRecipientDialogComponent } from '../update-recipient-dialog/update-recipient-dialog.component';
import { MktSMSTemplate } from '../mkt-sms-template-dialog/mkt-sms-template-dialog.component';
import { MktEmailTemplate } from 'app/modules/app-components/mkt-email-template-dialog/mkt-email-template-dialog.component';

import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { find, sortBy } from 'lodash';
import { concernsTypeList } from 'app/constants/csv/constants';
import { TranslateService } from '@ngx-translate/core';
import { getLanguagePreferences, setLanguagePreferences } from 'app/constants/language-translate';

@Component({
  selector: 'app-send-dialog',
  templateUrl: './send-dialog.component.html',
  styleUrls: ['./send-dialog.component.scss'],
  providers: [DialogService],
})
export class SendDialogComponent implements OnInit, OnDestroy {
  @ViewChild('sendDialog', { static: true }) sendDialog: ElementRef;

  card: any = {
    messages: {
      heading: 'Display Messages',
      content: 'Allow customers to view messages on estimates and invoices.',
      switch: false,
    },
    feed: {
      heading: 'Display Activity Feed',
      content: 'Allow customers to view messages on estimates and invoices.',
      switch: false,
    },
    schedule: {
      heading: 'Schedule pick up',
      content: 'Choose date and time for vehicle pick up',
      switch: true,
    },
    reminders: {
      heading: 'Reminder',
      content: 'Send the customer reminder on',
      switch: true,
    },
    isShowPaymentDetails: {
      heading: 'Show payment details on invoice',
      content: '',
      switch: true,
    },
  };
  defaultReminder: any = [
    {
      primary: true,
      message: '',
      label: 'tomorrow',
      day: 1,
      time: this.getCurrentSelectedTime().value,
    },
    {
      primary: true,
      message: '',
      label: ': 2 days from now',
      day: 2,
      time: this.getCurrentSelectedTime().value,
    },
  ];
  recipients = {
    emails: [],
    phones: [],
  };
  reminderRecipients = {
    emails: [],
    phones: [],
  };

  usd: string = currency.USD;
  reminderRecipientTooltip: string = '';
  notificationRecipientTooltip: string = '';
  useConfirmationRecipient: boolean = false;
  isProcessing: boolean = false;
  concernTypes = concernsTypeList;

  reminders: any[] = [...this.defaultReminder];
  customer: any = {};
  vehicle: any = {};
  timezones: any = {};
  title: string = '';
  data: any = {};
  order: any = {};
  company: any = {};
  shop: any = {};
  templateType: string = '';
  isEstimateDeposit: boolean = false;
  isResendEstDeposit: boolean = false;
  isEnhancedEstimateAndInvoiceEnabled: boolean = false;
  inspectionId: string = '';
  subject: string = '';
  content: string = '';
  templateSubject: string = '';
  templateContents: string = '';
  defaultContent: string = '';
  inspectionTitle: string = '';
  isEmailSelected: boolean = false;
  isSMSSelected: boolean = false;
  isReminderEnabled: boolean = false;
  isDisplayMessage: boolean = false;
  isDisplayFeed: boolean = false;
  isSchedulePickUp: boolean = true;
  isShowPaymentDetails: boolean = false;
  pickUpDateTime: any;
  selectedTime: any = {};
  pickUpDate: any = '';
  times = [];
  reminderTemplate: any = {};
  currentTime: any;
  payment = {
    cash: 0,
    cheque: 0,
    card: 0,
    creditPayment: 0,
    thirdParty: 0,
  };
  estimateTemplate: any = {};
  invoiceTemplate: any = {};
  inspectionTemplate: any = {};
  vehiclePickupTemplate: any = {};
  approvalReminderTemplate: any = {};
  estimateDepositTemplate: any = {};
  estimateDepositReminderTemplate: any = {};
  templateKeys = {
    ESTIMATE: 'estimateTemplate',
    INVOICE: 'invoiceTemplate',
    INSPECTION: 'inspectionTemplate',
    INVOICE_VEHICLE_PICKUP: 'vehiclePickupTemplate',
    ESTIMATE_APPROVAL_REMINDER: 'approvalReminderTemplate',
    ESTIMATE_DEPOSIT_REQUEST: 'estimateDepositTemplate',
    DEPOSIT_REQUEST_REMINDER: 'estimateDepositReminderTemplate',
  };
  serverTime: any = 0;
  isInspectionsVisible: boolean = true;
  isAttachmentsExpanded: boolean = true;
  inspectionsStatus: any = {};
  contacts: any[] = [];
  orderAttachments: any[] = [];
  attachmentUpdate = {};
  isMarketingOptOutEnabled: boolean = false;
  isMarketingEnabled: boolean = false;
  isShowPaymentInPdf: boolean = false;
  isEstimateDepositEnabled: boolean = false;
  dataServiceSubscription: Subscription;
  hasFollowUps: boolean = false;
  estimationData: any = {};
  isSent: boolean = false;
  contact: any = {};
  inspections: any[] = [];
  isReminderDisabled: boolean = false;
  unsubscriptionTooltip: string = '';
  focus: any = { depositAmt: false };
  errors: any = {};
  depositText: any = '';
  isAutomatedFollowUpEnabled: boolean = false;
  isAutomatedFollowUpOnByCustomer: boolean = false;
  isMultiLocationEnabled: boolean = false;
  isFleetCustomer: boolean = false;
  defaultSchedulePickUpState: boolean = false;
  isFetching: boolean = true;
  isScheduleLoading: boolean = true;
  isSendReminderDisabled: boolean = false;
  isSendReminderSetManually: boolean = false;
  companyLocalization: boolean = false;
  isSavingLanguage: boolean = false;
  currentLang: string = 'en';
  templates: any = [];
  customerId: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    public dateService: DateService,
    private attachmentService: AttachmentService,
    private currencyPipe: CurrencyPipe,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    const { data, templateType, openFrom, isEstimateDeposit, isResendEstDeposit, isFleetCustomer, isEnhancedEstimateAndInvoiceEnabled, lang, companyLocalization }: any = this.dConfig.data;

    this.templateType = templateType;
    this.order = data;
    if (data.customer && data.customer.customerId) {
      this.httpService.getCustomerPreferredLanguage(data.customer.customerId).then((res: any) => {
        if (res.preferredLanguage) {
          this.currentLang = res.preferredLanguage.toLowerCase() || 'en';
        }
        this.customerId = data.customer.customerId;
        this.initiateSendDialog(data, templateType, openFrom);
      });
    }
    this.times = time;
    this.isFleetCustomer = isFleetCustomer;
    this.companyLocalization = this.dataService.companyLocalization;
    this.isEstimateDeposit = isEstimateDeposit;
    this.isResendEstDeposit = isResendEstDeposit;
    this.isEnhancedEstimateAndInvoiceEnabled = isEnhancedEstimateAndInvoiceEnabled;
    this.isMultiLocationEnabled = this.helperService.getCompany().isMultiLocationEnabled;
    this.setDataListener();
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  async switchLanguage() {
    try {
      if (this.isSavingLanguage || this.isProcessing) return;
      this.isSavingLanguage = true;
      const currentLang = this.currentLang === 'en' ? 'fr' : 'en';

      this.translate.use(currentLang);
      this.currentLang = currentLang;
      await this.httpService.updateCustomer({ _id: this.customerId, preferredLanguage: 'fr'.toUpperCase() });
    this.dataService.langChangeSubject.next(this.currentLang);
      this.populateTemplates();
    } catch (err) {
    } finally {
      this.isSavingLanguage = false;
    }
  }

  initiateSendDialog(data: any, sendType: string, openFrom: string) {
    this.isFetching = true;
    this.isScheduleLoading = true;
    this.httpService
      .getSendEstimateData({ orderId: data?._id, customerId: data?.customer?.customerId, sendType, populateOrder: openFrom === 'kanban' })
      .then(
        (res: any) => {
          if (res) {
            const { templates, company, shop, contact, order, serverTime, timezones } = res;

            if (openFrom === 'kanban') {
              if (order && order.vehicle && order.vehicle.vehicleId && order.vehicle.vehicleId._id) {
                order.vehicle = { ...order.vehicle, ...order.vehicle.vehicleId };
                order.vehicle.vehicleId = order.vehicle.vehicleId._id;
              }
            }

            // this.company = company;
            this.shop = shop;
            this.timezones = timezones;
            this.serverTime = new Date(serverTime);

            if (this.isMultiLocationEnabled) {
              this.defaultSchedulePickUpState = this.shop?.appsettings?.isSchedulePickupOn;
            } else {
              this.defaultSchedulePickUpState = company?.appsettings?.isSchedulePickupOn;
            }

            if (templates && templates.length) {
              this.templates = templates;
              this.populateTemplates();
            }

            if (order) data = order;

            if (contact) {
              this.contact = contact;

              if (this.contact.contactEntityId) {
                data.customer.firstName = this.contact.contactEntityId.firstName;
                data.customer.lastName = this.contact.contactEntityId.lastName;
              }

              this.setRecipient();
            }

            this.setPickUpDateTime();

            if (data && data._id) {
              let isNotAllDataAvailable: boolean = false;

              if (data.vehicle) {
                const { name, year, make, model, engine } = data.vehicle;

                isNotAllDataAvailable = !name || !year || !make || !model || !engine;
              }

              if (openFrom === 'kanban' && data.vehicle && data.vehicle.vehicleId && isNotAllDataAvailable) {
                if (data.vehicle.vehicleId._id) {
                  data.vehicle.vehicleId = data.vehicle.vehicleId._id;
                }
                this.httpService.getVehicleById(data.vehicle.vehicleId).then(
                  (result: any) => {
                    if (result && result.vehicles) {
                      data.vehicle.name = result.vehicles.name;
                      data.vehicle.year = result.vehicles.year;
                      data.vehicle.make = result.vehicles.make;
                      data.vehicle.model = result.vehicles.model;
                      data.vehicle.engine = result.vehicles.engine;
                    }
                    this.populateData(data);
                  },
                  (err: any) => {
                    this.helperService.showToaster('error', err);
                  },
                );
              } else {
                this.populateData(data);
              }
            }

            if (this.contact) {
              this.setRecipient();
            }
          }
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isScheduleLoading = false;
        this.isFetching = false;
      });
  }

  setDataListener() {
    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.isMarketingOptOutEnabled = this.dataService.isMarketingOptOutEnabled;
          this.isMarketingEnabled = this.dataService.isMarketingEnabled;
          this.isShowPaymentInPdf = this.dataService.isShowPaymentInPdf;
          this.isEstimateDepositEnabled = this.dataService.isEstimateDepositEnabled;
          this.dataServiceSubscription.unsubscribe();
        }
      }
    });
    this.isMarketingEnabled = this.dataService.isMarketingEnabled;
    this.isShowPaymentInPdf = this.dataService.isShowPaymentInPdf;
    this.isEstimateDepositEnabled = this.dataService.isEstimateDepositEnabled;
    this.isMarketingOptOutEnabled = this.dataService.isMarketingOptOutEnabled;
  }

  /** Handle attachment checkbox change */
  handleAttachmentChange(attachment: any, value: any, keyChanged: any) {
    this.attachmentUpdate[attachment._id] = { title: attachment.title, [keyChanged]: value, updateType: 'visibility' };

    if (attachment._id) {
      this.httpService
        .updateEstimateAttachment(attachment._id, { title: attachment.title, [keyChanged]: value, updateType: 'visibility' })
        .catch((err) => this.helperService.showToaster('error', 'Unable to update attachment'));
    }
  }

  handleOpenTemplate(marketingTemplate: any) {
    const component = marketingTemplate && marketingTemplate.templateType === 'SMS' ? MktSMSTemplate : MktEmailTemplate;

    this.dialogService.open(component, {
      styleClass: 'add-dialog mkt-email-template-dialog-dialog',
      showHeader: false,
      data: { isOpenedFromCampaign: true, campaignTemplateId: marketingTemplate && marketingTemplate.marketingTemplateId, campaignTemplateText: marketingTemplate.text, isReadOnly: true },
    });
  }

  /** Populating all templates */
  populateTemplates() {
    this.templates.forEach((template) => {
      if (!this.companyLocalization) this.currentLang = 'en';
      if (template.language === this.currentLang.toUpperCase()) {
        const templateKey = this.templateKeys[template.type];
        this[templateKey] = template;
      }
    });
    if (this.templateType === templateTypes.invoice && this.defaultSchedulePickUpState) {
      this.subject = this.parseTemplate(this.vehiclePickupTemplate.subject);
      this.content = this.parseTemplate(this.vehiclePickupTemplate.contents);
    } else {
      const templateKey = this.templateKeys[this.templateType];
      const template = this[templateKey];
      if (template) {
        this.templateSubject = template.subject;
        this.templateContents = template.contents;
        this.subject = this.parseTemplate(template.subject);
        this.content = this.parseTemplate(template.contents);
      }
    }
  }

  /** Populate all reminders */
  populateReminder() {
    this.isReminderEnabled = true;
    this.reminders.forEach((reminder) => {
      let content = this.approvalReminderTemplate.contents;
      if (this.templateType === templateTypes.estimateDeposit) {
        content = this.estimateDepositReminderTemplate.contents;
      }
      reminder.message = this.parseTemplate(content);
    });
  }

  /** Setting pickup time (current date + 24 hours skipping the business days) */
  setPickUpDateTime() {
    this.pickUpDateTime = this.dateService.getCurrentDateTimeTz(new Date(this.serverTime).getTime());

    const currentMinutes = this.dateService.getNearestSuccessorQuarterHour(moment(this.pickUpDateTime).format('mm'));
    const currentHours = moment(this.pickUpDateTime)
      .add(Number(currentMinutes) === 0 ? 1 : 0, 'hour')
      .format('HH');

    if (this.helperService.isAppleDevice()) {
      this.pickUpDateTime = new Date(`${this.dateService.madeDateStringIOSCompatible(this.dateService.formatDate(this.pickUpDateTime, datetimeFormat.yyymmdd))} ${currentHours}:${currentMinutes}`);
    } else {
      this.pickUpDateTime = new Date(`${this.dateService.formatDate(this.pickUpDateTime, datetimeFormat.yyymmdd)} ${currentHours}:${currentMinutes}`);
    }
    const timeOption = find(this.times, { value: `${currentHours}:${currentMinutes}` });

    this.selectedTime = {
      i: timeOption && timeOption.i,
      label: moment(this.pickUpDateTime).format('hh:mma'),
      value: moment(this.pickUpDateTime).format('hh:mma'),
    };
    this.pickUpDate = this.pickUpDateTime;
  }

  /** Populating the date */
  async populateData(data: any) {
    const { customer = {}, vehicle = {}, orderStatus, title, code, invCode, authorized, paid, unpaid, card, cheque, creditPayment, thirdParty, cash, total, _id, services, depositRequest } = data;

    this.customer = {
      customerId: customer.customerId,
      firstName: customer.firstName,
      displayName: customer.displayName,
      fullName: customer.fullName,
      lastName: customer.lastName || '',
      email: customer.email,
      phone: customer.phone,
      isEmail: customer.isEmail,
      isSMS: customer.isSMS,
    };
    this.vehicle = {
      vehicleId: vehicle.vehicleId,
      name: vehicle.name,
      year: vehicle.year,
      make: vehicle.make,
      model: vehicle.model,
      engine: vehicle.engine,
    };
    if (vehicle && vehicle.vehicleId && vehicle.vehicleId._id) {
      this.vehicle = {
        vehicleId: vehicle.vehicleId._id,
        name: vehicle.vehicleId.name,
        year: vehicle.vehicleId.year,
        make: vehicle.vehicleId.make,
        model: vehicle.vehicleId.model,
        engine: vehicle.vehicleId.engine,
      };
    }

    this.order = {
      _id,
      code,
      title,
      unpaid,
      total,
      invCode,
      services,
      authorized,
      orderStatus,
      paid: card + cheque + cash + creditPayment + thirdParty,
      customer: this.customer,
      vehicle: this.vehicle,
      depositRequest,
    };

    this.payment = { card, cheque, cash, creditPayment, thirdParty };
    this.company = this.dataService.company;
    this.inspections = [];

    if (depositRequest) {
      this.depositText = `${this.currencyPipe.transform(depositRequest.amount || 0, this.usd)} (Amount already deposited: $${this.order.paid})`;
      this.order.depositAmt = this.order.depositRequest.amount;
    } else {
      this.depositText = `$${0} (Amount already deposited: $${this.order.paid})`;
      this.order.depositAmt = 0;
    }

    data.services.forEach(({ _id, includeInInvoice, inspection }) => {
      if (inspection && inspection.inspectionId && includeInInvoice) {
        this.inspections.push({ ...inspection.inspectionId, _id });
        this.inspectionsStatus[_id] = true;
      }
    });

    this.isEmailSelected = customer.isEmail;
    this.isSMSSelected = customer.isSMS;

    if (this.templateType === templateTypes.invoice && this.defaultSchedulePickUpState) {
      this.subject = this.parseTemplate(this.vehiclePickupTemplate.subject);
      this.content = this.parseTemplate(this.vehiclePickupTemplate.contents);
    } else {
      const templateKey = this.templateKeys[this.templateType];
      const template = this[templateKey];
      if (template) {
        this.templateSubject = template.subject;
        this.templateContents = template.contents;
        this.subject = this.parseTemplate(template.subject);
        this.content = this.parseTemplate(template.contents);
      }
    }

    this.updateInspectionInEmail();

    if (this.order.orderStatus === 'invoice') {
      this.isSchedulePickUp = this.defaultSchedulePickUpState;
    }

    this.getOrderAttachments();
    this.populateReminder();

    if (this.isEmailSelected || this.isSMSSelected) {
      this.handleUseConfirmationRecipientChange(this.isEmailSelected || this.isSMSSelected);
    } else {
      this.isSendReminderDisabled = !((this.customer?.email && this.isEmailSelected) || (this.customer?.phone && this.isSMSSelected));
    }
  }

  getOrderAttachments() {
    this.attachmentService
      .getOrderAttachment(this.order._id, { category: 'EXTERNAL' })
      .then((response: any) => {
        if (!response.metaData.totalRecords) return;
        this.orderAttachments = sortBy(response.records, 'createdAt');
      })
      .catch((error) => this.helperService.showToaster('error', error));
  }

  /** handle toggling statuses  */
  toggleActiveState(type: string, active: boolean) {
    this[type] = active;

    if (['isEmailSelected', 'isSMSSelected'].includes(type)) {
      if (type === 'isSMSSelected') {
        this.isSMSSelected = !!(this.customer?.phone && this.isSMSSelected);
      } else {
        this.isEmailSelected = !!(this.customer?.email && this.isEmailSelected);
      }
      this.setRecipient(type);
      this.isSendReminderDisabled = !((this.customer?.email && this.isEmailSelected) || (this.customer?.phone && this.isSMSSelected));
      if (!this.isSendReminderSetManually && !this.useConfirmationRecipient) {
        this.handleUseConfirmationRecipientChange((this.customer?.email && this.isEmailSelected) || (this.customer?.phone && this.isSMSSelected));
      } else {
        this.handleUseConfirmationRecipientChange(this.useConfirmationRecipient);
      }
      return;
    }

    if (type === 'isShowPdf') {
      active ? (this.isShowPaymentDetails = true) : (this.isShowPaymentDetails = false);
    }

    // if (type === 'isReminder' && this.templateType === 'ESTIMATE_DEPOSIT_REQUEST') {
    //   if (active) {
    //     this.setPickUpDateTime();
    //     this.subject = this.parseTemplate(this.estimateDepositReminderTemplate.subject);
    //     this.content = this.parseTemplate(this.estimateDepositReminderTemplate.contents);
    //     this.communicationTypeWithReminder = true;
    //   } else {
    //     this.subject = this.parseTemplate(this.estimateDepositTemplate.subject);
    //     this.content = this.parseTemplate(this.estimateDepositTemplate.contents);
    //     this.communicationTypeWithReminder = false;
    //   }
    // }
    if (type === 'isSchedulePickUp') {
      if (active) {
        this.setPickUpDateTime();
        this.subject = this.parseTemplate(this.vehiclePickupTemplate.subject);
        this.content = this.parseTemplate(this.vehiclePickupTemplate.contents);
      } else {
        this.subject = this.parseTemplate(this.invoiceTemplate.subject);
        this.content = this.parseTemplate(this.invoiceTemplate.contents);
      }
    }
  }

  toggleInspectionVisibilty() {
    this.isInspectionsVisible = !this.isInspectionsVisible;
  }

  toggleAttachmentVisibilty() {
    this.isAttachmentsExpanded = !this.isAttachmentsExpanded;
  }

  parseTemplate(content: string) {
    const parseData = {
      pickUpDateTime: this.pickUpDateTime,
      company: this.isMultiLocationEnabled ? this.shop : this.company,
      customer: this.customer,
      vehicle: this.vehicle,
      order: {
        title: this.order.title,
        code: this.order.code,
        invCode: this.order.invCode,
        paid: this.payment.card + this.payment.cheque + this.payment.cash + this.payment.creditPayment + this.payment.thirdParty,
        authStatus: this.order.authorized ? 'approved' : 'not approved',
        orderStatus: this.order.orderStatus,
        total: this.order.total && this.order.total.grand,
        deposit_amount: this.order.depositAmt || 0,
      },
    };

    return this.helperService.templateParser(content, parseData, false, this.timezones);
  }

  revertParse(content: string) {
    const parseData = {
      pickUpDateTime: this.pickUpDateTime,
      company: this.isMultiLocationEnabled ? this.shop : this.company,
      customer: this.customer,
      vehicle: this.vehicle,
      order: {
        title: this.order.title,
        code: this.order.code,
        invCode: this.order.invCode,
        paid: this.payment.card + this.payment.cheque + this.payment.cash + this.payment.creditPayment + this.payment.thirdParty,
        authStatus: this.order.authorized ? 'approved' : 'not approved',
        orderStatus: this.order.orderStatus,
        total: this.order.total && this.order.total.grand,
      },
    };

    return this.helperService.revertTemplateParsing(content, parseData);
  }

  preview() {
    let isEnhancedEstimateAndInvoiceEnabled = false;
    if (this.isMultiLocationEnabled) {
      isEnhancedEstimateAndInvoiceEnabled = this.shop?.appsettings?.isEnhancedEstimateAndInvoiceEnabled;
    } else {
      isEnhancedEstimateAndInvoiceEnabled = this.company?.appsettings?.isEnhancedEstimateAndInvoiceEnabled;
    }
    let url = isEnhancedEstimateAndInvoiceEnabled && this.templateType === templateTypes.invoice ? `${config.redirectUrl.previewEnhancedInvoice}` : `${config.redirectUrl.preview}`;

    if (this.order._id) {
      url += this.order._id;
    }

    if (this.inspectionId) {
      url += `/${this.inspectionId}`;
    }
    if (this.companyLocalization) {
      this.helperService.openPageInNewTab(
        this.helperService.constructQueryParams(url, {
          isPreview: true,
          lang: this.currentLang,
          localization: this.companyLocalization,
          isShowPaymentDetails: this.isShowPaymentInPdf ? true : false,
          inspections: Object.keys(this.inspectionsStatus)
            .map((id) => id)
            .filter((id) => this.inspectionsStatus[id]),
        }),
      );
    } else {
      this.helperService.openPageInNewTab(
        this.helperService.constructQueryParams(url, {
          isPreview: true,
          isShowPaymentDetails: this.isShowPaymentInPdf ? true : false,
          inspections: Object.keys(this.inspectionsStatus)
            .map((id) => id)
            .filter((id) => this.inspectionsStatus[id]),
        }),
      );
    }
  }

  onDateTimeChange(datetime: any) {
    const dateStr = moment(datetime).format('MM-DD-YYYY');
    const timeStr = moment(this.pickUpDateTime).format('HH:mm');
    const dateTimeStr = new Date(`${dateStr} ${timeStr}`);
    this.content = this.revertParse(this.content);
    this.subject = this.revertParse(this.subject);

    this.pickUpDateTime = dateTimeStr;
    this.content = this.parseTemplate(this.vehiclePickupTemplate.contents);
    this.subject = this.parseTemplate(this.subject);
  }

  onSelectStartTime(pickUpTime: any) {
    this.selectedTime = pickUpTime;
    const dateStr = moment(this.pickUpDateTime).format(datetimeFormat.yyymmdd);
    let dateTimeStr: any;

    if (this.helperService.isAppleDevice()) {
      dateTimeStr = new Date(this.dateService.madeDateStringIOSCompatible(`${dateStr} ${pickUpTime.value}`));
    } else {
      dateTimeStr = new Date(`${dateStr} ${pickUpTime.value}`);
    }

    this.content = this.revertParse(this.content);
    this.subject = this.revertParse(this.subject);
    this.pickUpDateTime = dateTimeStr;
    this.content = this.parseTemplate(this.vehiclePickupTemplate.contents);
    this.subject = this.parseTemplate(this.subject);
  }

  subjectChange(value: string = '') {
    this.subject = value;
  }

  onSubmit() {
    let contacts = [];
    if (!this.isEmailSelected && !this.isSMSSelected) {
      this.helperService.showToaster('error', messages.communicationPreference);
      return;
    }

    if (this.order.orderStatus === 'estimate') {
      contacts = [...this.recipients.emails, ...this.recipients.phones, ...this.reminderRecipients.emails, ...this.reminderRecipients.phones];

      if (!contacts.length) {
        this.helperService.showToaster('error', 'No contact selected');
        return;
      }
    } else {
      contacts = [...this.recipients.emails, ...this.recipients.phones];

      if (!contacts.length) {
        this.helperService.showToaster('error', 'No contact selected');
        return;
      }
    }

    const data = this.order;
    let communicationType = 'inspection';
    if (this.templateType === templateTypes.invoice) {
      communicationType = 'invoice';
    } else if (this.templateType === templateTypes.estimate) {
      communicationType = 'estimate';
    } else if (this.templateType === templateTypes.estimateDeposit) {
      communicationType = 'estimate_deposit_request';
    }

    data.customer = this.customer;
    data.vehicle = this.vehicle;
    data.reminders = this.isReminderEnabled && !this.isReminderDisabled ? this.reminders : [];
    data.recipients = [...this.recipients.emails, ...this.recipients.phones];
    data.reminderRecipients = [...this.reminderRecipients.emails, ...this.reminderRecipients.phones];
    data.communication = {
      type: communicationType,
      isSMS: this.isSMSSelected,
      isEmail: this.isEmailSelected,
      isMessage: this.isDisplayMessage,
      isActivity: this.isDisplayFeed,
      phone: this.customer && this.customer.phone,
      email: this.customer && this.customer.email,
      subject: this.subject,
      contents: this.content,
      latest: true,
    };

    data.isPickupScheduled = this.isSchedulePickUp;

    if (this.isSchedulePickUp) {
      data.pickupDate = this.pickUpDateTime;
    }

    data.inspectionsStatus = this.inspectionsStatus;

    this.sendOrderInvoice(data);
  }

  handleReminderEnableChange(isReminderEnabled: boolean) {
    this.isReminderEnabled = isReminderEnabled;
  }

  sendOrderInvoice(data: any) {
    let appointment: any = {};
    const endTime = this.helperService.addDuration(this.pickUpDateTime, 15, 'm');
    if (this.templateType === templateTypes.invoice && this.isSchedulePickUp) {
      appointment = {
        customer: this.customer,
        estimate: this.data,
        vehicle: this.vehicle,
        isEmail: this.customer.isEmail,
        isSMS: this.customer.isSMS,
        title: `${(this.vehicle && this.vehicle.name) || 'Untitled'} Pickup`,
        color: '#4E94C8',
        startDateTime: `${this.helperService.parseDateForTimeZone(this.pickUpDateTime)}`,
        endDateTime: `${this.helperService.parseDateForTimeZone(endTime)}`,
      };
    }

    this.isProcessing = true;
    if (this.isEstimateDeposit && this.isEstimateDepositEnabled) {
      if (!data.depositAmt) {
        this.errors.depositAmt = 'Deposit amount must be greater than 0';
        this.isProcessing = false;
        return;
      }
      if (this.isResendEstDeposit) data.resend = true;

      this.httpService
        .sendEstimateDeposit(data._id, { ...data, appointment, isShowPaymentDetails: this.isShowPaymentDetails })
        .then(
          (estimationData: any) => {
            if (this.templateType === templateTypes.invoice) {
              this.helperService.showToaster('success', messages.invoiceSent);
            } else if (this.templateType === templateTypes.estimate) {
              // this.helperService.showToaster('success', messages.estimateDepositSent);
            } else {
              this.helperService.showToaster('success', messages.emailSent);
            }
            const estimateDepositAttributePX = {
              customer: this.customer,
              estimate: this.data,
              vehicle: this.vehicle,
              isEmailSelected: this.isEmailSelected,
              isSMSSelected: this.isSMSSelected,
              roNumber: data.code,
            };

            if (this.currentLang.toLowerCase() === 'fr') {
              this.helperService.postGainsightPXEvent(`${this.templateType} Sent in French`, estimateDepositAttributePX);
            }

            if (this.hasFollowUps && this.isMarketingEnabled) {
              this.estimationData = estimationData;
              this.isSent = true;
            } else {
              this.close(estimationData);
            }

            if (estimationData.orderStatus === 'estimate' && estimationData.sendEstimate) {
              this.order.sendEstimate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(estimationData.sendEstimate).getTime()), datetimeFormat.mmmdyyhhmmaa);
            }

            // now finally send, attachment update if any
            if (Object.keys(this.attachmentUpdate).length) {
              Object.keys(this.attachmentUpdate).forEach((key) => {
                this.httpService.updateEstimateAttachment(key, this.attachmentUpdate[key]).catch((err) => this.helperService.showToaster('error', 'Unable to update attachment'));
              });
            }
            this.dataService.sendData(this.dataService.typePassData('deposit-estimate', {}));
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isProcessing = false;
          this.dataService.sendData(this.dataService.typePassData('refresh-attachment', {}));
        });
    } else {
      this.httpService
        .sendEstimation(data._id, { ...data, appointment, isShowPaymentDetails: this.isShowPaymentDetails }, this.isEnhancedEstimateAndInvoiceEnabled)
        .then(
          async (estimationData: any) => {
            if (Object.keys(data.inspectionsStatus).length > 0 && this.dataService.isGainSightPXEnabled) {
              const estimateSentDvi: any = {
                inspectionsCount: Object.keys(data.inspectionsStatus).length,
                inspectionsName: this.getAttachedInspections(data.services),
                roNumber: data.code,
                customerName: data.customer?.fullName,
                vehicleName: data.vehicle?.name,
              };

              (<any>window).aptrinsic('track', 'Estimate Sent with DVI', estimateSentDvi);
            }
            const estimateAttributePX = {
              customer: this.customer,
              estimate: this.data,
              vehicle: this.vehicle,
              isEmailSelected: this.isEmailSelected,
              isSMSSelected: this.isSMSSelected,
              roNumber: data.code,
            };

            if (this.currentLang.toLowerCase() === 'fr') {
              this.helperService.postGainsightPXEvent(`${this.templateType} sent in French`, estimateAttributePX);
            }

            if (this.dataService.isDvi2Enabled && this.dataService.isGainSightPXEnabled) {
              try {
                const concerns = await this.httpService.getOrderConcerns({ orderId: data._id });
                if (concerns.length) this.postCustomerConcernsEvent(data, concerns);
              } catch (err) {
                console.log(err);
                this.helperService.showToaster('error', err);
              }
            }

            if (this.templateType === templateTypes.invoice) {
              if (this.currentLang.toLowerCase() !== 'fr') {
                this.helperService.postGainsightPXEvent('invoices sent', {});
              }
              this.helperService.showToaster('success', messages.invoiceSent);
            } else if (this.templateType === templateTypes.estimate) {
              this.helperService.showToaster('success', messages.estimateSent);
            } else {
              this.helperService.showToaster('success', messages.emailSent);
            }

            if (this.hasFollowUps && this.isMarketingEnabled) {
              this.estimationData = estimationData;
              this.isSent = true;
            } else {
              this.close(estimationData);
            }

            if (estimationData.orderStatus === 'estimate' && estimationData.sendEstimate) {
              this.order.sendEstimate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(estimationData.sendEstimate).getTime()), datetimeFormat.mmmdyyhhmmaa);
            }

            // now finally send, attachment update if any
            if (Object.keys(this.attachmentUpdate).length) {
              Object.keys(this.attachmentUpdate).forEach((key) => {
                this.httpService.updateEstimateAttachment(key, this.attachmentUpdate[key]).catch((err) => this.helperService.showToaster('error', 'Unable to update attachment'));
              });
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isProcessing = false;
          this.dataService.sendData(this.dataService.typePassData('refresh-attachment', {}));
        });
    }
  }

  postCustomerConcernsEvent(estimate, concerns) {
    const estimateSentConcerns: any = {
      roNumber: estimate.code,
      customerName: estimate.customer?.fullName,
      vehicleName: estimate.vehicle?.name,
      totalNoOfConcerns: concerns.length,
      typesOfConcerns: this.getConcernsDetails(concerns).concernTypes,
      numberOfInspectionFindings: this.getConcernsDetails(concerns).inspectionItems,
      numberOfServices: this.getConcernsDetails(concerns).services,
    };

    (<any>window).aptrinsic('track', 'Estimate sent with concerns', estimateSentConcerns);
  }

  getConcernsDetails(concerns) {
    let concernTypes = '';
    let inspectionItems = 0;
    let services = 0;
    concerns.forEach((concern) => {
      if (concern.concernType) {
        concernTypes += !concernTypes ? `${this.getConcernTypeLabel(concern)}` : `, ${this.getConcernTypeLabel(concern)}`;
      }
      if (concern.findings?.length) inspectionItems += concern.findings?.length;
      if (concern.services?.length) services += concern.services?.length;
    });

    return { concernTypes, inspectionItems, services };
  }

  getConcernTypeLabel(concern) {
    return this.concernTypes.find((element) => element.value === concern.concernType)?.label;
  }

  getAttachedInspections(services) {
    let inspectionNames = '';
    services.forEach((element) => {
      if (element.inspection && element.inspection.inspectionId) {
        if (element.inspection.title) inspectionNames += !inspectionNames ? `${element.inspection.title}` : `, ${element.inspection.title}`;
        else inspectionNames += !inspectionNames ? `${element.inspection.inspectionId.title}` : `, ${element.inspection.inspectionId.title}`;
      }
    });

    return inspectionNames;
  }

  /** Scrolling the modal to the bottom */
  scrollToBottom() {
    setTimeout(() => {
      this.sendDialog.nativeElement.scrollTop = this.sendDialog.nativeElement.scrollHeight;
    }, 100);
  }

  deleteReminder(index: number) {
    if (this.reminders && this.reminders.length) {
      this.reminders.splice(index, 1);
    }
  }

  addReminder() {
    if (this.reminders && this.reminders.length) {
      this.reminders.push(this.defaultReminder);
    }
  }

  getCurrentSelectedTime(): any {
    const nowDate = this.helperService.convertDate(new Date());
    const currentHour = nowDate.format('HH');
    const currentMin = nowDate.format('mm');

    if (time) {
      const startHourSlots = time.filter((t) => t.hour === currentHour);

      if (this.helperService.toNumber(currentMin) >= 45) {
        if (this.times) {
          return this.times.filter((t) => t.i === startHourSlots[3].i + 1)[0];
        } else {
          return {};
        }
      } else if (this.helperService.toNumber(currentMin) >= 30 && this.helperService.toNumber(currentMin) < 45) {
        return startHourSlots[3];
      } else if (this.helperService.toNumber(currentMin) >= 15 && this.helperService.toNumber(currentMin) < 30) {
        return startHourSlots[2];
      } else if (this.helperService.toNumber(currentMin) >= 0 && this.helperService.toNumber(currentMin) < 15) {
        return startHourSlots[1];
      }
    }

    return {};
  }

  handleInspectionChange(serviceId: string, isChecked: boolean) {
    this.inspectionsStatus[serviceId] = isChecked;
    this.updateInspectionInEmail();
  }

  updateInspectionInEmail() {
    const status = [...Array.from(new Set(Object.values(this.inspectionsStatus)))];

    if (!status.length) {
      return;
    }

    const inspectionRegex = new RegExp(' & inspection', 'ig');

    if (status.length === 1 && !status[0]) {
      if (this.order.orderStatus === 'estimate') {
        this.subject = this.subject.replace(inspectionRegex, '');
      }
      if (this.content) {
        this.content = this.content.replace(inspectionRegex, '');
      }
    } else {
      const estimateRegex = new RegExp('(estimate|invoice)', 'ig');

      if (this.order.orderStatus === 'estimate') {
        this.subject = this.subject.replace(inspectionRegex, '');
        this.subject = this.subject.replace(estimateRegex, '$1 & inspection');
      }
      if (this.content) {
        this.content = this.content.replace(inspectionRegex, '');
        this.content = this.content.replace(estimateRegex, '$1 & inspection');
      }
    }
  }

  /** Closing the send dialog */
  close(data: any) {
    if (this.isMarketingEnabled && this.isSent) {
      this.ref.close(this.estimationData);
    } else {
      this.ref.close(data);
    }
    this.dataService.sendData(this.dataService.typePassData('refresh-attachment', {}));
  }

  openUpdateRecipientDialog(type: string) {
    if (!this.isSMSSelected && !this.isEmailSelected) return;
    if (this.useConfirmationRecipient && type === 'reminder') return;

    let recipients = [];

    if (type === 'confirmation') {
      recipients = [...this.recipients.emails.map(({ value }) => value), ...this.recipients.phones.map(({ value }) => value)];
    } else {
      recipients = [...this.reminderRecipients.emails.map(({ value }) => value), ...this.reminderRecipients.phones.map(({ value }) => value)];
    }

    const ref = this.dialogService.open(UpdateRecipientDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        customerId: this.order.customer.customerId,
        email: this.order.customer.email,
        phone: this.order.customer.phone,
        recipients: this.helperService.deepCopy(recipients),
        contactOnPhone: this.isSMSSelected,
        contactOnEmail: this.isEmailSelected,
        isFleetCustomer: this.isFleetCustomer,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const contactNotifMap = {};
        const recipients = {
          emails: [],
          phones: [],
        };

        if (data.contacts && data.contacts && data.contacts.length) {
          for (let i = 0; i < data.contacts.length; i++) {
            const { _id, value, contactType, isChecked, isMarketingNotifEnabled, isOperationalNotifEnabled } = data.contacts[i];
            const contact = {
              value,
              recipientId: _id,
              type: contactType,
              isMarketingNotifEnabled,
              isOperationalNotifEnabled,
            };

            contactNotifMap[_id] = { isMarketingNotifEnabled, isOperationalNotifEnabled };

            if (isChecked) {
              if (contactType === 'email') {
                recipients.emails.push(contact);
              } else {
                recipients.phones.push(contact);
              }
            }
          }
        }

        if (type === 'confirmation') {
          this.recipients = this.helperService.deepCopy(recipients);

          if (this.useConfirmationRecipient) {
            this.reminderRecipients = this.helperService.deepCopy(this.recipients);
          }
        } else {
          this.reminderRecipients = this.helperService.deepCopy(recipients);
        }

        this.setOperationalNotification(contactNotifMap);

        this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
        this.isReminderDisabled = !(
          this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length +
          this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length
        );
        this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
        this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
      }

      onClose.unsubscribe();
    });
  }

  setRecipient(type: string = '') {
    this.contacts = this.contact.contactInfo || [];

    if (this.contact.contactEntityId) {
      this.order.customer.firstName = this.contact.contactEntityId.firstName;
      this.order.customer.lastName = this.contact.contactEntityId.lastName;
    }

    if (!this.isEmailSelected) {
      this.recipients.emails = [];
      this.reminderRecipients.emails = [];
    }

    if (!this.isSMSSelected) {
      this.recipients.phones = [];
      this.reminderRecipients.phones = [];
    }

    if (this.contacts && this.contacts.length) {
      this.contacts.forEach(({ _id, value, contactType, isPrimary, isMarketingNotifEnabled, isOperationalNotifEnabled }: any) => {
        if (isPrimary) {
          if (contactType === 'email' && this.isEmailSelected && ['', 'isEmailSelected'].includes(type)) {
            this.recipients.emails = [
              {
                type: 'email',
                value: value,
                recipientId: _id,
                isMarketingNotifEnabled,
                isOperationalNotifEnabled,
              },
            ];
          } else if (contactType === 'mobile' && this.isSMSSelected && ['', 'isSMSSelected'].includes(type)) {
            this.recipients.phones = [
              {
                type: 'mobile',
                value: value,
                recipientId: _id,
                isMarketingNotifEnabled,
                isOperationalNotifEnabled,
              },
            ];
          }
        }
      });
    }

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
    }

    this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
    this.isReminderDisabled = !(
      this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length +
      this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length
    );
    this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
    this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
  }

  setOperationalNotification(contactMap: any) {
    if (this.recipients.emails && this.recipients.emails.length) {
      this.recipients.emails.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.reminderRecipients.emails && this.reminderRecipients.emails.length) {
      this.reminderRecipients.emails.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.recipients.phones && this.recipients.phones.length) {
      this.recipients.phones.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.reminderRecipients.phones && this.reminderRecipients.phones.length) {
      this.reminderRecipients.phones.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }
  }

  handleSendReminderDisabledChange() {
    this.isSendReminderSetManually = true;
  }

  handleUseConfirmationRecipientChange(useConfirmationRecipient: boolean) {
    this.useConfirmationRecipient = useConfirmationRecipient;

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
      this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
      this.isReminderDisabled = !(
        this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length +
        this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length
      );
      this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
    }
    if (this.templateType === 'ESTIMATE_DEPOSIT_REQUEST') {
      this.toggleActiveState('isReminder', true);
    }
  }
  /** Setting the focused inputs */
  focusInput(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';

    if (this.order.depositRequest) {
      this.depositText = `${this.currencyPipe.transform(this.order.depositRequest.amount || 0, this.usd)} (Amount already deposited: $${this.order.paid})`;
    } else {
      this.depositText = `$${0} (Amount already deposited: $${this.order.paid})`;
    }
  }

  /** Removeing the errors from the fields */
  blurInput(name: any, type: string) {
    this.focus[type] = false;
  }

  /** Getting values from the inputs */
  handleChange(name: string, value: number) {
    this.order[name] = Number(value);
    this.depositText = `$${this.order[name]} (Amount already deposited: $${this.order.paid})`;
    if (this.order.total.grand < Number(value)) {
      this.errors.depositAmt = 'Request amount must be less than Estimate’s remaining bal.';
      return;
    } else {
      this.errors.depositAmt = '';
    }

    this.content = this.parseTemplate(this.templateContents);
    this.subject = this.parseTemplate(this.templateSubject);
  }

  updateScheduleSettings(defaultSchedulePickUpState: boolean) {
    this.defaultSchedulePickUpState = defaultSchedulePickUpState;
  }
}
